//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import ChatActions from '../../Actions/chat';
import Constants from '../../constants';
import AccessibleButtonWrapper from '../../Icon/components/AccessibleButtonWrapper.react';

function _openChat() {
  ChatActions.closeChatModal();
  ChatActions.openChat();
}

function _sendEmail() {
  ChatActions.closeChatModal();

  // we want to return true so that the href happens
  return true;
}

type Props = {
  email?:string,
};

function ChatInfoModal(props:Props) {
  const address = props.email || 'support@naturebox.com';

  return (
    <div>
      <h2>CONTACT US</h2>
      <div className="text-2 bold">Online Chat</div>
      <AccessibleButtonWrapper
        className="live-chat"
        label="Start a live chat"
        action={_openChat}
      >
        Start a live chat
      </AccessibleButtonWrapper>

      <div className="text-2 bold">Email</div>
      <a className="email-chat" onClick={_sendEmail} href={`mailto:${address}`}>{address}</a>
    </div>
  );
}

export default modal<Props>(ChatInfoModal, {
  name: Constants.CHAT_INFO_MODAL,
  className: 'chat-info-modal',
});
